import { Link } from "react-router-dom";

export const Brand = ({ to = "/" }) => (
  <Link to={to} data-testid="brand-logo-link" className="inline-flex items-center">
    <img src="/assets/logo.png" alt="DaddyAnna" className="h-9 w-auto" />
  </Link>
);
